module.exports = __webpack_public_path__ + "static/aliona_bohomol-b34b5230d4b5b7c8ad68d6949466f56d.png";